import { Flex, HelpIndicator, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import { OwnersAndControllersRowItem } from "../types";
import {
  escalationModalTriggerIcon,
  profileName as profileNameStyle,
} from "./styles_vanilla.css";

type Props = {
  data: OwnersAndControllersRowItem;
  onEscalationIconClick: (profileId: number) => void;
  showEscalationIcon: boolean;
};

export const ProfileCellRenderer = ({
  data,
  onEscalationIconClick,
  showEscalationIcon,
}: Props) => {
  const profileId = data?.actions?.id;
  const profileName = data.name;

  const shouldShowCreateEscalationIcon = profileId && showEscalationIcon;

  return (
    <Flex alignItems="center" gap={Sizes.SM}>
      <Text asSpan className={profileNameStyle} title={profileName}>
        {profileName}
      </Text>
      {shouldShowCreateEscalationIcon && (
        <Flex>
          <HelpIndicator
            id={`escalation-tooltip-${profileId}`}
            placement="top"
            content="Create escalation"
          >
            <Icon
              type="arrow-circle-up"
              className={escalationModalTriggerIcon}
              onClick={() => onEscalationIconClick(profileId)}
              data-testid={`escalation-icon-${profileId}`}
            />
          </HelpIndicator>
        </Flex>
      )}
    </Flex>
  );
};
